import type { TFunction } from 'i18next';

export type NarrationTrack = {
  id: string;
  title: string;
  text: string;
};

export function getRouteNarration(pathname: string, t: TFunction): NarrationTrack[] {
  const route = pathname.split('?')[0];

  if (route === '/') {
    return [
      { id: 'landing-welcome', title: t('narration.tracks.welcomeTitle'), text: t('narration.tracks.welcomeText') },
      { id: 'landing-philosophy', title: t('narration.tracks.philosophyTitle'), text: t('narration.tracks.philosophyText') },
      { id: 'landing-districts', title: t('narration.tracks.districtsTitle'), text: t('narration.tracks.districtsText') },
      { id: 'landing-journey', title: t('narration.tracks.journeyTitle'), text: t('narration.tracks.journeyText') },
      { id: 'landing-closing', title: t('narration.tracks.closingTitle'), text: t('narration.tracks.closingText') },
    ];
  }

  const routeMap: Record<string, { title: string; text: string }> = {
    '/profile': { title: t('narration.routes.profileTitle'), text: t('narration.routes.profileText') },
    '/districts': { title: t('narration.routes.districtsTitle'), text: t('narration.routes.districtsText') },
    '/itineraries': { title: t('narration.routes.itineraryTitle'), text: t('narration.routes.itineraryText') },
    '/culinary': { title: t('narration.routes.culinaryTitle'), text: t('narration.routes.culinaryText') },
    '/stories': { title: t('narration.routes.storiesTitle'), text: t('narration.routes.storiesText') },
    '/made-in-sala': { title: t('narration.routes.makersTitle'), text: t('narration.routes.makersText') },
    '/responsible': { title: t('narration.routes.responsibleTitle'), text: t('narration.routes.responsibleText') },
    '/today': { title: t('narration.routes.todayTitle'), text: t('narration.routes.todayText') },
    '/search': { title: t('narration.routes.searchTitle'), text: t('narration.routes.searchText') },
    '/collection': { title: t('narration.routes.collectionTitle'), text: t('narration.routes.collectionText') },
    '/leaderboard': { title: t('narration.routes.leaderboardTitle'), text: t('narration.routes.leaderboardText') },
    '/game/motif': { title: t('narration.routes.gameTitle'), text: t('narration.routes.gameText') },
    '/map': { title: t('narration.routes.mapTitle'), text: t('narration.routes.mapText') },
    '/360': { title: t('view360.title'), text: t('view360.narrationIntro') },
  };

  const item = routeMap[route];
  return item ? [{ id: `route-${route.replace(/\W+/g, '-')}`, ...item }] : [];
}
